export default __webpack_public_path__ + "static/media/mechanism.1acfd121.png";